module.exports = __webpack_public_path__ + "img/_chico_padel_rascacielos_bono.3bf8bb08.png";